import { useState, useEffect } from 'react';

const useDistrictData = () => {
  const [district, setDistrict] = useState([]);
  const [loadingDistrict, setLoading] = useState(true);
  const [errorDistrict, setError] = useState(null);

  useEffect(() => {
    const fetchDistrict = async () => {
      try {
        const response = await fetch(`https://bdapi.vercel.app/api/v.1/district`);
        if (!response.ok) {
          throw new Error("Failed to fetch ");
        }
        const data = await response.json();
        setDistrict(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDistrict();
  }, []);

  return { district, loadingDistrict, errorDistrict };
};

export default useDistrictData;
